import React from "react"

export default function Emoji({ icon = "", label = "" }) {
	return (
		<span role="img" aria-label={label}>
			{icon}
		</span>
	)
}
